export const CASINO_THEME_STORAGE_KEY = 'greyrock-casino-theme';

export function isCasinoRoute(pathname = '') {
  return /^(?:\/(?:en|fr))?\/(?:calendar|admin\/(?:reservations|view-clients|add-client|upload-csv|share-emails|delete-period|view-records|admin-control))\/?$/.test(pathname);
}

export function readCasinoTheme() {
  try {
    return window.localStorage.getItem(CASINO_THEME_STORAGE_KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

// Runs before the page paints, including after a language change or refresh.
export const casinoThemeInitScript = `(() => {
  if (!(${isCasinoRoute.toString()})(window.location.pathname)) return;
  let theme = 'light';
  try { if (localStorage.getItem('${CASINO_THEME_STORAGE_KEY}') === 'dark') theme = 'dark'; } catch {}
  document.documentElement.dataset.casinoTheme = theme;
})();`;
